import styled from 'styled-components';

export const StyledBookmarksModal = styled.div`
  align-items: center;
  background-color: #fbfbfb;
  box-shadow: 2px 4px 8px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  left: 50%;
  padding: 1.25rem 2rem;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;

  > svg {
    margin-right: 1rem;
  }
`;
